import React from 'react';
import { Layout, Typography, Divider, Card, Space, Button } from 'antd';
import { FileTextOutlined, RocketOutlined, ToolOutlined, WarningOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import './style.css';

const { Content, Footer } = Layout;
const { Title, Paragraph, Text } = Typography;

const TerminosCondiciones = () => {
    const navigate = useNavigate();

    return (
        <Layout style={{ background: '#f0f2f5', minHeight: '100vh' }}>
            <Content style={{ padding: '50px 20px' }}>
                <Card
                    style={{
                        maxWidth: '900px',
                        margin: '0 auto',
                        borderRadius: '12px',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.05)'
                    }}
                >
                    <Button
                        type="link"
                        icon={<ArrowLeftOutlined />}
                        onClick={() => navigate(-1)}
                        style={{ color: '#22BABB', marginBottom: '20px', padding: 0 }}
                    >
                        Volver atrás
                    </Button>

                    <div style={{ textAlign: 'center', marginBottom: '40px' }}>
                        <FileTextOutlined style={{ fontSize: '48px', color: '#22BABB' }} />
                        <Title level={1} style={{ marginTop: '10px', color: '#22BABB' }}>Términos y Condiciones</Title>
                        <Text type="secondary">Versión 1.0 - Febrero 2026</Text>
                    </div>

                    <Divider />

                    <Space direction="vertical" size="large" style={{ width: '100%' }}>
                        <section>
                            <Title level={4}><RocketOutlined /> 1. Aceptación del Servicio</Title>
                            <Paragraph>
                                Al registrarse y utilizar la plataforma <b>YUGONUB</b>, el usuario acepta cumplir con los presentes términos. Este sistema se proporciona como una herramienta de gestión administrativa y su uso está sujeto a la suscripción activa del usuario.
                            </Paragraph>
                        </section>

                        <section>
                            <Title level={4}><ToolOutlined /> 2. Propiedad Intelectual</Title>
                            <Paragraph>
                                Todo el código, diseño, logotipos y arquitectura de software son propiedad exclusiva de <b>YUGONUB</b>. El usuario adquiere una licencia de uso no exclusiva y no transferible; queda prohibida la ingeniería inversa o reproducción total o parcial del sistema.
                            </Paragraph>
                        </section>

                        <section>
                            <Title level={4}><WarningOutlined /> 3. Responsabilidad Tributaria y Facturación</Title>
                            <Paragraph>
                                YUGONUB actúa como una plataforma de gestión administrativa y control de inventarios. Respecto a las obligaciones legales, el usuario reconoce que:
                                <ul>
                                    <li><b>Obligación de Facturar:</b> Es responsabilidad exclusiva del usuario determinar si está obligado a emitir factura electrónica o documento equivalente electrónico según la normativa vigente de la DIAN.</li>
                                    <li><b>Documentos Internos:</b> Los comprobantes impresos por el sistema que no cuenten con validación electrónica (CUFE/CUDE y QR) son estrictamente para control interno y no poseen validez legal como soporte de impuestos ante la DIAN.</li>
                                    <li><b>Integración con Terceros:</b> Si el usuario opta por la integración con proveedores tecnológicos de facturación electrónica, YUGONUB no se hace responsable por la pérdida de folios, rechazos de la DIAN o fallas en la firma digital externa.</li>
                                </ul>
                            </Paragraph>
                        </section>

                        <section>
                            <Title level={4}><WarningOutlined /> 4. Limitación de Responsabilidad</Title>
                            <Paragraph>
                                YUGONUB no garantiza que el uso del sistema asegure el cumplimiento automático de todas las leyes fiscales del usuario. Bajo ninguna circunstancia seremos responsables por:
                                <ul>
                                    <li><b>Sanciones Administrativas:</b> Multas, cierres de establecimientos o sanciones impuestas por la DIAN u otras autoridades debido al uso indebido del software.</li>
                                    <li><b>Precisión de Datos:</b> La veracidad de los reportes depende de la correcta parametrización de impuestos (IVA, Impoconsumo, etc.) realizada por el usuario.</li>
                                    <li><b>Fuerza Mayor:</b> Fallas eléctricas, de internet o ataques cibernéticos externos que afecten la disponibilidad de la plataforma en la sede del cliente.</li>
                                </ul>
                            </Paragraph>
                        </section>

                        <section>
                            <Title level={4}>5. Modificaciones</Title>
                            <Paragraph>
                                YUGONUB se reserva el derecho de actualizar o modificar las funcionalidades del software para mejorar la experiencia del usuario o cumplir con normativas legales. Las actualizaciones menores se realizarán de forma automática.
                            </Paragraph>
                        </section>

                        <section>
                            <Title level={4}>6. Suspensión del Servicio y Datos</Title>
                            <Paragraph>
                                En caso de impago de la suscripción, YUGONUB se reserva el derecho de suspender el acceso a la plataforma. El usuario es responsable de exportar sus reportes de ventas y datos contables antes de la fecha de corte. YUGONUB no garantiza la recuperación de información tras 30 días de inactividad de la cuenta por falta de pago.
                            </Paragraph>
                        </section>

                        <section style={{ background: '#f9f9f9', padding: '20px', borderRadius: '8px' }}>
                            <Text strong>Nota Legal Provisoria:</Text>
                            <Paragraph italic style={{ fontSize: '13px', marginTop: '10px' }}>
                                Este documento es un borrador informativo para los usuarios de Yugonub. Se recomienda la revisión periódica del mismo,
                                ya que puede ser actualizado para cumplir con nuevas normativas legales vigentes.
                            </Paragraph>
                        </section>
                    </Space>
                </Card>
            </Content>

            <Footer style={{ textAlign: 'center', background: 'transparent', padding: '50px 0' }}>
                <Divider />
                <Space split={<Divider type="vertical" />} style={{ marginBottom: '10px' }}>
                    <Link to="/terminos-y-condiciones" style={{ color: '#8c8c8c' }}>Términos y condiciones</Link>
                    <Link to="/politica-privacidad" style={{ color: '#8c8c8c' }}>Política de Privacidad</Link>
                    <Link to="/" style={{ color: '#8c8c8c' }}>Soporte</Link>
                </Space>
                <br />
                <Text type="secondary" style={{ fontSize: '12px' }}>
                    Hecho con ❤️ por el equipo de <span style={{ color: '#22BABB', fontWeight: 'bold' }}>YUGONUB</span> en Colombia.
                </Text>
            </Footer>
        </Layout>
    );
};

export default TerminosCondiciones;